import React from 'react';
import PositiveToast from '@/components/toasts/PositiveToast';
import ToastMessage from '@/components/toasts/ToastMessage';

const ApprovedToast = ({ items }) => (
  <PositiveToast className="aridhia-approved-toast">
    <ToastMessage items={items} multiple="toast.approves" single="toast.approved" />
  </PositiveToast>
);

export default ApprovedToast;
